import { Fragment } from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonCommentActitivy = () => {
    // Get theme from localStorage (default to 'light' if not set)
    const theme = localStorage.getItem("theme") || "light";

    // Define colors for light and dark themes
    const skeletonColors = theme === "dark"
        ? { baseColor: "#23272F", highlightColor: "#3A3F4B" }
        : { baseColor: "#CECECE", highlightColor: "#E8E8E8" };

    return (
        <Fragment>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
                <div key={item} className="flex items-start mb-4 border-b border-gray-300 last:border-b-0 px-2 pb-2">
                    <div className="flex-1">
                        <Skeleton {...skeletonColors} height={10} width={60} className="mt-1" />
                        <Skeleton {...skeletonColors} height={12} width={100} className="mt-2" />
                        <Skeleton {...skeletonColors} height={12} width="75%" className="mt-1" />
                    </div>
                    <div className="flex flex-col items-end">
                        <Skeleton 
                            {...skeletonColors} 
                            height={64} 
                            width={48} 
                            style={{ borderRadius: "0.25rem", marginLeft: "0.75rem" }} 
                        />
                        <Skeleton {...skeletonColors} height={10} width={48} className="mt-1" />
                    </div>
                </div>
            ))}
        </Fragment>
    )
}

export default SkeletonCommentActitivy